export const provinces = [
  { label: "Alberta", value: "AB" },
  { label: "British Columbia", value: "BC" },
  { label: "Manitoba", value: "MB" },
  { label: "New Brunswick", value: "NB" },
  { label: "Newfoundland and Labrador", value: "NL" },
  { label: "Northwest Territories", value: "NT" },
  { label: "Nova Scotia", value: "NS" },
  { label: "Nunavut", value: "NU" },
  { label: "Ontario", value: "ON" },
  { label: "Prince Edward Island", value: "PE" },
  { label: "Quebec", value: "PQ" },
  { label: "Saskatchewan", value: "SK" },
  { label: "Yukon", value: "YT" }
];

export const states = [
  {
    value: "AL",
    label: "Alabama"
  },
  {
    value: "AK",
    label: "Alaska"
  },
  {
    value: "AS",
    label: "American Samoa"
  },
  {
    value: "AR",
    label: "Arkansas"
  },
  {
    value: "AZ",
    label: "Arizona"
  },
  {
    value: "CA",
    label: "California"
  },
  {
    value: "CO",
    label: "Colorado"
  },
  {
    value: "CT",
    label: "Connecticut"
  },
  {
    value: "DC",
    label: "District Of Columbia"
  },
  {
    value: "DE",
    label: "Delaware"
  },
  {
    value: "FM",
    label: "Federated States Of Micronesia"
  },
  {
    value: "FL",
    label: "Florida"
  },
  {
    value: "GA",
    label: "Georgia"
  },
  {
    value: "GU",
    label: "Guam"
  },
  {
    value: "HI",
    label: "Hawaii"
  },
  {
    value: "ID",
    label: "Idaho"
  },
  {
    value: "IA",
    label: "Iowa"
  },
  {
    value: "IL",
    label: "Illinois"
  },
  {
    value: "IN",
    label: "Indiana"
  },
  {
    value: "KS",
    label: "Kansas"
  },
  {
    value: "KY",
    label: "Kentucky"
  },
  {
    value: "LA",
    label: "Louisianna"
  },
  {
    value: "ME",
    label: "Maine"
  },
  {
    value: "MH",
    label: "Marshall Islands"
  },
  {
    value: "MD",
    label: "Maryland"
  },
  {
    value: "MA",
    label: "Massachusetts"
  },
  {
    value: "MI",
    label: "Michigan"
  },
  {
    value: "MN",
    label: "Minnesota"
  },
  {
    value: "MS",
    label: "Mississippi"
  },
  {
    value: "MO",
    label: "Missouri"
  },
  {
    value: "MT",
    label: "Montana"
  },
  {
    value: "NC",
    label: "North Carolina"
  },
  {
    value: "ND",
    label: "North Dakota"
  },
  {
    value: "NE",
    label: "Nebraska"
  },
  {
    value: "NV",
    label: "Nevada"
  },
  {
    value: "NH",
    label: "New Hampshire"
  },
  {
    value: "NJ",
    label: "New Jersey"
  },
  {
    value: "NM",
    label: "New Mexico"
  },
  {
    value: "NY",
    label: "New York"
  },
  {
    value: "NP",
    label: "Northern Mariana Islands"
  },
  {
    value: "OH",
    label: "Ohio"
  },
  {
    value: "OK",
    label: "Oklahoma"
  },
  {
    value: "PW",
    label: "Palau"
  },
  {
    value: "OR",
    label: "Oregon"
  },
  {
    value: "PA",
    label: "Pennsylvania"
  },
  {
    value: "PR",
    label: "Puerto Rico"
  },
  {
    value: "RI",
    label: "Rhode Island"
  },
  {
    value: "SC",
    label: "South Carolina"
  },
  {
    value: "SD",
    label: "South Dakota"
  },
  {
    value: "TN",
    label: "Tennessee"
  },
  {
    value: "TX",
    label: "Texas"
  },
  {
    value: "UT",
    label: "Utah"
  },
  {
    value: "VT",
    label: "Vermont"
  },
  {
    value: "VI",
    label: "Virgin Islands"
  },
  {
    value: "VA",
    label: "Virginia"
  },
  {
    value: "WA",
    label: "Washington"
  },
  {
    value: "WV",
    label: "West Virgina"
  },
  {
    value: "WI",
    label: "Wisconsin"
  },
  {
    value: "WY",
    label: "Wyoming"
  }
];

export const countries = [
  {
    value: "124",
    label: "Canada"
  },
  {
    value: "840",
    label: "United States of America"
  },
  {
    value: "004",
    label: "Afghanistan"
  },
  {
    value: "248",
    label: "Aland Islands"
  },
  {
    value: "008",
    label: "Albania"
  },
  {
    value: "012",
    label: "Algeria"
  },
  {
    value: "016",
    label: "American Samoa"
  },
  {
    value: "020",
    label: "Andorra"
  },
  {
    value: "024",
    label: "Angola"
  },
  {
    value: "660",
    label: "Anguilla"
  },
  {
    value: "010",
    label: "Antarctica"
  },
  {
    value: "028",
    label: "Antigua and Barbuda"
  },
  {
    value: "032",
    label: "Argentina"
  },
  {
    value: "051",
    label: "Armenia"
  },
  {
    value: "533",
    label: "Aruba"
  },
  {
    value: "036",
    label: "Australia"
  },
  {
    value: "040",
    label: "Austria"
  },
  {
    value: "031",
    label: "Azerbaijan"
  },
  {
    value: "044",
    label: "Bahamas"
  },
  {
    value: "048",
    label: "Bahrain"
  },
  {
    value: "050",
    label: "Bangladesh"
  },
  {
    value: "052",
    label: "Barbados"
  },
  {
    value: "112",
    label: "Belarus"
  },
  {
    value: "056",
    label: "Belgium"
  },
  {
    value: "084",
    label: "Belize"
  },
  {
    value: "204",
    label: "Benin"
  },
  {
    value: "060",
    label: "Bermuda"
  },
  {
    value: "064",
    label: "Bhutan"
  },
  {
    value: "068",
    label: "Bolivia:  Plurinational State of"
  },
  {
    value: "535",
    label: "Bonaire:  Sint Eustatius and Saba"
  },
  {
    value: "070",
    label: "Bosnia and Herzegovina"
  },
  {
    value: "072",
    label: "Botswana"
  },
  {
    value: "074",
    label: "Bouvet Island"
  },
  {
    value: "076",
    label: "Brazil"
  },
  {
    value: "086",
    label: "British Indian Ocean Territory"
  },
  {
    value: "096",
    label: "Brunei Darussalam"
  },
  {
    value: "100",
    label: "Bulgaria"
  },
  {
    value: "854",
    label: "Burkina Faso"
  },
  {
    value: "108",
    label: "Burundi"
  },
  {
    value: "116",
    label: "Cambodia"
  },
  {
    value: "120",
    label: "Cameroon"
  },
  {
    value: "132",
    label: "Cape Verde"
  },
  {
    value: "136",
    label: "Cayman Islands"
  },
  {
    value: "140",
    label: "Central African Republic"
  },
  {
    value: "148",
    label: "Chad"
  },
  {
    value: "152",
    label: "Chile"
  },
  {
    value: "156",
    label: "China"
  },
  {
    value: "162",
    label: "Christmas Island"
  },
  {
    value: "166",
    label: "Cocos (Keeling) Islands"
  },
  {
    value: "170",
    label: "Colombia"
  },
  {
    value: "174",
    label: "Comoros"
  },
  {
    value: "178",
    label: "Congo"
  },
  {
    value: "180",
    label: "Congo:  the Democratic Republic of the"
  },
  {
    value: "184",
    label: "Cook Islands"
  },
  {
    value: "188",
    label: "Costa Rica"
  },
  {
    value: "384",
    label: "Côte d'Ivoire"
  },
  {
    value: "191",
    label: "Croatia"
  },
  {
    value: "192",
    label: "Cuba"
  },
  {
    value: "531",
    label: "Curaçao"
  },
  {
    value: "196",
    label: "Cyprus"
  },
  {
    value: "203",
    label: "Czech Republic"
  },
  {
    value: "208",
    label: "Denmark"
  },
  {
    value: "262",
    label: "Djibouti"
  },
  {
    value: "212",
    label: "Dominica"
  },
  {
    value: "214",
    label: "Dominican Republic"
  },
  {
    value: "218",
    label: "Ecuador"
  },
  {
    value: "818",
    label: "Egypt"
  },
  {
    value: "222",
    label: "El Salvador"
  },
  {
    value: "226",
    label: "Equatorial Guinea"
  },
  {
    value: "232",
    label: "Eritrea"
  },
  {
    value: "233",
    label: "Estonia"
  },
  {
    value: "748",
    label: "Eswatini"
  },
  {
    value: "231",
    label: "Ethiopia"
  },
  {
    value: "238",
    label: "Falkland Islands (Malvinas)"
  },
  {
    value: "234",
    label: "Faroe Islands"
  },
  {
    value: "242",
    label: "Fiji"
  },
  {
    value: "246",
    label: "Finland"
  },
  {
    value: "250",
    label: "France"
  },
  {
    value: "254",
    label: "French Guiana"
  },
  {
    value: "258",
    label: "French Polynesia"
  },
  {
    value: "260",
    label: "French Southern Territories"
  },
  {
    value: "266",
    label: "Gabon"
  },
  {
    value: "270",
    label: "Gambia"
  },
  {
    value: "268",
    label: "Georgia"
  },
  {
    value: "276",
    label: "Germany"
  },
  {
    value: "288",
    label: "Ghana"
  },
  {
    value: "292",
    label: "Gibraltar"
  },
  {
    value: "300",
    label: "Greece"
  },
  {
    value: "304",
    label: "Greenland"
  },
  {
    value: "308",
    label: "Grenada"
  },
  {
    value: "312",
    label: "Guadeloupe"
  },
  {
    value: "316",
    label: "Guam"
  },
  {
    value: "320",
    label: "Guatemala"
  },
  {
    value: "831",
    label: "Guernsey"
  },
  {
    value: "324",
    label: "Guinea"
  },
  {
    value: "624",
    label: "Guinea-Bissau"
  },
  {
    value: "328",
    label: "Guyana"
  },
  {
    value: "332",
    label: "Haiti"
  },
  {
    value: "334",
    label: "Heard Island and McDonald Islands"
  },
  {
    value: "336",
    label: "Holy See (Vatican City State)"
  },
  {
    value: "340",
    label: "Honduras"
  },
  {
    value: "344",
    label: "Hong Kong"
  },
  {
    value: "348",
    label: "Hungary"
  },
  {
    value: "352",
    label: "Iceland"
  },
  {
    value: "356",
    label: "India"
  },
  {
    value: "360",
    label: "Indonesia"
  },
  {
    value: "364",
    label: "Iran:  Islamic Republic of"
  },
  {
    value: "368",
    label: "Iraq"
  },
  {
    value: "372",
    label: "Ireland"
  },
  {
    value: "833",
    label: "Isle of Man"
  },
  {
    value: "376",
    label: "Israel"
  },
  {
    value: "380",
    label: "Italy"
  },
  {
    value: "388",
    label: "Jamaica"
  },
  {
    value: "392",
    label: "Japan"
  },
  {
    value: "832",
    label: "Jersey"
  },
  {
    value: "400",
    label: "Jordan"
  },
  {
    value: "398",
    label: "Kazakhstan"
  },
  {
    value: "404",
    label: "Kenya"
  },
  {
    value: "296",
    label: "Kiribati"
  },
  {
    value: "408",
    label: "Korea:  Democratic People's Republic of"
  },
  {
    value: "410",
    label: "Korea:  Republic of"
  },
  {
    value: "414",
    label: "Kuwait"
  },
  {
    value: "417",
    label: "Kyrgyzstan"
  },
  {
    value: "418",
    label: "Lao People's Democratic Republic"
  },
  {
    value: "428",
    label: "Latvia"
  },
  {
    value: "422",
    label: "Lebanon"
  },
  {
    value: "426",
    label: "Lesotho"
  },
  {
    value: "430",
    label: "Liberia"
  },
  {
    value: "434",
    label: "Libya"
  },
  {
    value: "438",
    label: "Liechtenstein"
  },
  {
    value: "440",
    label: "Lithuania"
  },
  {
    value: "442",
    label: "Luxembourg"
  },
  {
    value: "446",
    label: "Macao"
  },
  {
    value: "807",
    label: "Macedonia:  the Former Yugoslav Republic of"
  },
  {
    value: "450",
    label: "Madagascar"
  },
  {
    value: "454",
    label: "Malawi"
  },
  {
    value: "458",
    label: "Malaysia"
  },
  {
    value: "462",
    label: "Maldives"
  },
  {
    value: "466",
    label: "Mali"
  },
  {
    value: "470",
    label: "Malta"
  },
  {
    value: "584",
    label: "Marshall Islands"
  },
  {
    value: "474",
    label: "Martinique"
  },
  {
    value: "478",
    label: "Mauritania"
  },
  {
    value: "480",
    label: "Mauritius"
  },
  {
    value: "175",
    label: "Mayotte"
  },
  {
    value: "484",
    label: "Mexico"
  },
  {
    value: "583",
    label: "Micronesia:  Federated States of"
  },
  {
    value: "498",
    label: "Moldova:  Republic of"
  },
  {
    value: "492",
    label: "Monaco"
  },
  {
    value: "496",
    label: "Mongolia"
  },
  {
    value: "499",
    label: "Montenegro"
  },
  {
    value: "500",
    label: "Montserrat"
  },
  {
    value: "504",
    label: "Morocco"
  },
  {
    value: "508",
    label: "Mozambique"
  },
  {
    value: "104",
    label: "Myanmar"
  },
  {
    value: "516",
    label: "Namibia"
  },
  {
    value: "520",
    label: "Nauru"
  },
  {
    value: "524",
    label: "Nepal"
  },
  {
    value: "528",
    label: "Netherlands"
  },
  {
    value: "540",
    label: "New Caledonia"
  },
  {
    value: "554",
    label: "New Zealand"
  },
  {
    value: "558",
    label: "Nicaragua"
  },
  {
    value: "562",
    label: "Niger"
  },
  {
    value: "566",
    label: "Nigeria"
  },
  {
    value: "570",
    label: "Niue"
  },
  {
    value: "574",
    label: "Norfolk Island"
  },
  {
    value: "580",
    label: "Northern Mariana Islands"
  },
  {
    value: "578",
    label: "Norway"
  },
  {
    value: "512",
    label: "Oman"
  },
  {
    value: "586",
    label: "Pakistan"
  },
  {
    value: "585",
    label: "Palau"
  },
  {
    value: "275",
    label: "Palestine:  State of"
  },
  {
    value: "591",
    label: "Panama"
  },
  {
    value: "598",
    label: "Papua New Guinea"
  },
  {
    value: "600",
    label: "Paraguay"
  },
  {
    value: "604",
    label: "Peru"
  },
  {
    value: "608",
    label: "Philippines"
  },
  {
    value: "612",
    label: "Pitcairn"
  },
  {
    value: "616",
    label: "Poland"
  },
  {
    value: "620",
    label: "Portugal"
  },
  {
    value: "630",
    label: "Puerto Rico"
  },
  {
    value: "634",
    label: "Qatar"
  },
  {
    value: "638",
    label: "Réunion"
  },
  {
    value: "642",
    label: "Romania"
  },
  {
    value: "643",
    label: "Russian Federation"
  },
  {
    value: "646",
    label: "Rwanda"
  },
  {
    value: "652",
    label: "Saint Barthélemy"
  },
  {
    value: "654",
    label: "Saint Helena:  Ascension and Tristan da Cunha"
  },
  {
    value: "659",
    label: "Saint Kitts and Nevis"
  },
  {
    value: "662",
    label: "Saint Lucia"
  },
  {
    value: "663",
    label: "Saint Martin (French part)"
  },
  {
    value: "666",
    label: "Saint Pierre and Miquelon"
  },
  {
    value: "670",
    label: "Saint Vincent and the Grenadines"
  },
  {
    value: "882",
    label: "Samoa"
  },
  {
    value: "674",
    label: "San Marino"
  },
  {
    value: "678",
    label: "Sao Tome and Principe"
  },
  {
    value: "682",
    label: "Saudi Arabia"
  },
  {
    value: "686",
    label: "Senegal"
  },
  {
    value: "688",
    label: "Serbia"
  },
  {
    value: "690",
    label: "Seychelles"
  },
  {
    value: "694",
    label: "Sierra Leone"
  },
  {
    value: "702",
    label: "Singapore"
  },
  {
    value: "534",
    label: "Sint Maarten (Dutch part)"
  },
  {
    value: "703",
    label: "Slovakia"
  },
  {
    value: "705",
    label: "Slovenia"
  },
  {
    value: "090",
    label: "Solomon Islands"
  },
  {
    value: "706",
    label: "Somalia"
  },
  {
    value: "710",
    label: "South Africa"
  },
  {
    value: "239",
    label: "South Georgia and the South Sandwich Islands"
  },
  {
    value: "728",
    label: "South Sudan"
  },
  {
    value: "724",
    label: "Spain"
  },
  {
    value: "144",
    label: "Sri Lanka"
  },
  {
    value: "729",
    label: "Sudan"
  },
  {
    value: "740",
    label: "Suriname"
  },
  {
    value: "744",
    label: "Svalbard and Jan Mayen"
  },
  {
    value: "752",
    label: "Sweden"
  },
  {
    value: "756",
    label: "Switzerland"
  },
  {
    value: "760",
    label: "Syrian Arab Republic"
  },
  {
    value: "158",
    label: "Taiwan:  Province of China"
  },
  {
    value: "762",
    label: "Tajikistan"
  },
  {
    value: "834",
    label: "Tanzania:  United Republic of"
  },
  {
    value: "764",
    label: "Thailand"
  },
  {
    value: "626",
    label: "Timor-Leste"
  },
  {
    value: "768",
    label: "Togo"
  },
  {
    value: "772",
    label: "Tokelau"
  },
  {
    value: "776",
    label: "Tonga"
  },
  {
    value: "780",
    label: "Trinidad and Tobago"
  },
  {
    value: "788",
    label: "Tunisia"
  },
  {
    value: "792",
    label: "Turkey"
  },
  {
    value: "795",
    label: "Turkmenistan"
  },
  {
    value: "796",
    label: "Turks and Caicos Islands"
  },
  {
    value: "798",
    label: "Tuvalu"
  },
  {
    value: "800",
    label: "Uganda"
  },
  {
    value: "804",
    label: "Ukraine"
  },
  {
    value: "784",
    label: "United Arab Emirates"
  },
  {
    value: "826",
    label: "United Kingdom"
  },
  {
    value: "581",
    label: "United States Minor Outlying Islands"
  },
  {
    value: "858",
    label: "Uruguay"
  },
  {
    value: "860",
    label: "Uzbekistan"
  },
  {
    value: "548",
    label: "Vanuatu"
  },
  {
    value: "862",
    label: "Venezuela:  Bolivarian Republic of"
  },
  {
    value: "704",
    label: "Viet Nam"
  },
  {
    value: "092",
    label: "Virgin Islands:  British"
  },
  {
    value: "850",
    label: "Virgin Islands:  U.S."
  },
  {
    value: "876",
    label: "Wallis and Futuna"
  },
  {
    value: "732",
    label: "Western Sahara"
  },
  {
    value: "887",
    label: "Yemen"
  },
  {
    value: "894",
    label: "Zambia"
  },
  {
    value: "716",
    label: "Zimbabwe"
  }
];

export const countryCode = {
  USA: "840",
  canada: "124"
};

export const getFormattedProvince = province => {
  return [...provinces, ...states].find(
    newProvince =>
      province &&
      (newProvince.value === province.value || newProvince.value === province)
  );
};

export const countryFlag = {
  canada: "canada",
  northAmerica: "north america",
  fullCountryList: "full country list"
};
